export const skillSlots = ['Q', 'W', 'E', 'R', 'T'] as const;

export const maxSkillLevel = {
  Q: 5,
  W: 5,
  E: 5,
  R: 3,
  T: 2,
};
